import {gql} from 'graphql-request';
import {useQuery} from '@tanstack/react-query';
import {useLocation} from 'react-router-dom';
import magentoGraphQLClient from '../services/MagentoApi/graphqlClient';
import getMagentoPath from '../utils/getMagentoPath';

const CONTENT_DRIVEN_PLP_ROUTES = ['collections'];

const query = gql`
  query resolveRoute($url: String!) {
    route(url: $url) {
      relativeUrl: relative_url
      redirectCode: redirect_code
      type
      ... on CategoryTree {
        resourceId: id
      }
      ... on ProductInterface {
        resourceId: id
      }
    }
  }
`;

const RouteResolverQuery = (urlPath, magentoPath) =>
  useQuery(
    ['url_resolver', urlPath],
    async () => {
      const {route} = await magentoGraphQLClient.request(query, {
        url: magentoPath,
      });

      return route;
    },
    {enabled: !!magentoPath},
  );

const useRouteResolver = () => {
  const location = useLocation();
  const urlPath = location.pathname;
  const possiblePlpTypeParam = urlPath.split('/')[1];
  const magentoPath = CONTENT_DRIVEN_PLP_ROUTES.includes(possiblePlpTypeParam)
    ? undefined
    : getMagentoPath(urlPath);

  return RouteResolverQuery(urlPath, magentoPath);
};

export default useRouteResolver;
